import angular from 'angular';
import uiRouter from 'angular-ui-router';
import eventsComponent from './events.component';
import Event from './event/event';

let eventsModule = angular.module('events', [uiRouter, Event])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('events', {
        url: '/events',
        component: 'events',
        resolve: {
          $title: () => 'Eventi'
        }
      });
  })
  .component('events', eventsComponent)
  .name;

export default eventsModule;



// WEBPACK FOOTER //
// ./client/app/components/events/events.js